import { Show, SimpleShowLayout, TextField, NumberField, DateField } from 'react-admin';

export const SystemShow = () => (
  <Show>
    <SimpleShowLayout>
      <NumberField source="id" />
      <TextField source="releaseName" />
      <TextField source="host" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </SimpleShowLayout>
  </Show>
);
